export enum TodoPlannerViews {
  WeekView,
  MonthView,
}
